import React, { useContext, useEffect, useRef } from "react";
import { Button, Flex, Icon, Text } from "@chakra-ui/react";
import { MdCreditScore } from "react-icons/md";
import { Link } from "react-router-dom";
import useTranslation from '../../lib/i18n/useTranslation';
import { AuthContext } from "../../auth/lib/authContext";
import { ProfileContext } from "../../profile/lib/profileContext";
export default function SuccessPage() {
  const { t } = useTranslation();
  const authContext = useContext(AuthContext);
  const profileContext = useContext(ProfileContext);
  const hasRedirectedRef = useRef(false);
  const subscription = profileContext?.subscription;

  const redirectToHomeWithReload = () => {
    if (hasRedirectedRef.current) {
      return;
    }
    hasRedirectedRef.current = true;
    window.location.href = '/home';
  };

  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 4;
    const intervalMs = 2500;

    const refreshAfterPayment = async () => {
      try {
        if (authContext?.refresh) {
          await authContext.refresh();
        }
        if (profileContext?.refresh) {
          await profileContext.refresh({ skipProfile: true });
        }
      } catch (error) {
        console.error(error);
      } finally {
        attempts += 1;
        if (attempts >= maxAttempts) {
          redirectToHomeWithReload();
        }
      }
    };

    refreshAfterPayment();
    const intervalId = setInterval(refreshAfterPayment, intervalMs);
    const timeoutId = setTimeout(redirectToHomeWithReload, 12000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    if (subscription) {
      redirectToHomeWithReload();
    }
  }, [subscription]);

  return (
    <Flex
      alignItems={"stretch"}
      justifyContent={"center"}
      flex="1"
      padding={3}
      >
      <Flex
        flexDirection={"column"}
        border={"1px solid"}
        borderColor={"divider.grey"}
        backgroundColor={"white"}
        alignItems={"center"}
        justifyContent={"center"}
        flex="1"
        >
        <Icon
          as={MdCreditScore}
          color={'fill.green'}
          boxSize={'50px'}
          mb={3}
          borderRadius={"2px"}
        />
        <Text>{t('payment.thankYouSubscription')}</Text>
        <Text>{t('payment.paymentSuccessful')}</Text>
        <Link to="/home">
          <Button variant="coralOutline" mt={3}>{t('payment.goHome')}</Button>
        </Link>
      </Flex>
    </Flex>
  );
}
